// extracted by mini-css-extract-plugin
export default {"customDropdownScrollArea":"FavoriteMenuContent_module-XIJYEFZL_customDropdownScrollArea__59Dp0"};